import { Group, Switch, Paper } from '@mantine/core';
import { PropsWithChildren } from 'react';
import classes from 'global.module.css';
import { useCreateRuleFormContext } from 'context/FormContext';
import { get } from 'lodash';
import { useDefineRuleFormValidations } from '../../hooks/useDefineRuleFormValidations';

interface Props extends PropsWithChildren {
  title: string;
  dataField: string;
  disabled?: boolean;
}

export const AccordionWithSwitch = ({ title, children, dataField, disabled }: Props) => {
  const { getInputProps, setFieldValue, values, clearFieldError, errors } = useCreateRuleFormContext();
  const { value: enabled, onChange } = getInputProps(`${dataField}.enabled`);
  const { initialValues } = useDefineRuleFormValidations();

  const handleClick = () => {
    if (disabled) return;
    setFieldValue(dataField, get(initialValues, dataField));

    Object.keys(errors)
      .filter((value) => value.startsWith(dataField))
      .every((value) => clearFieldError(value));
    clearFieldError('data.heartRhythmMeasurement.oneConditionEnabled');
    onChange(!enabled);
  };

  return (
    <>
      <Paper
        shadow={'sm'}
        radius={'md'}
        p={10}
        withBorder
        className={disabled ? classes.cursorDisabled : classes.cursorPointer}
        onClick={handleClick}
      >
        <Group justify={'space-between'}>
          {title}
          <Switch
            onClick={(event) => event.stopPropagation()}
            checked={enabled}
            disabled={disabled || values.formDisabled}
          />
        </Group>
      </Paper>
      {enabled && children}
    </>
  );
};
